import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Non-invasive route performance observer.
 * Measures navigation start, page interactive timing, and API request counts.
 */
export default function RoutePerformanceTracker() {
    const location = useLocation();

    useEffect(() => {
        const routePath = location.pathname;
        const navStart = performance.now();
        window.__PERF_ROUTE_STATS__ = window.__PERF_ROUTE_STATS__ || {};
        window.__PERF_ROUTE_STATS__[routePath] = window.__PERF_ROUTE_STATS__[routePath] || {
            views: 0,
            apiCalls: 0,
            lastNavMs: 0
        };
        window.__PERF_ROUTE_STATS__[routePath].views++;

        const timer = setTimeout(() => {
            const duration = performance.now() - navStart;
            window.__PERF_ROUTE_STATS__[routePath].lastNavMs = Math.round(duration);
            if (process.env.NODE_ENV !== 'production') {
                console.debug(`[FRONTEND:PERF] Navigated to ${routePath} in ${Math.round(duration)}ms`);
            }
        }, 0);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return null;
}
